import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "../../lib/api";
import { CalendarClock, Check, Sprout, ChevronRight } from "lucide-react";
import { toast } from "sonner";

const pick = (l, hi, en) => (l === "हिंदी" ? hi : en);

export function PlannedCrops({ language, item }) {
  const navigate = useNavigate();
  const [plans, setPlans] = useState(null);
  useEffect(() => { api.get("/checkin/plans").then((r) => setPlans(r.data || [])).catch(() => setPlans([])); }, []);
  if (!plans || plans.length === 0) return null;

  const toggle = async (planId, itemKey) => {
    setPlans((ps) => ps.map((p) => p.id !== planId ? p : { ...p, checklist: p.checklist.map((c) => c.k === itemKey ? { ...c, done: !c.done } : c) }));
    try { await api.post(`/checkin/plan/${planId}/toggle`, { itemKey }); } catch { /* revert on error */ }
  };

  const sowNow = async (p) => {
    try { await api.post(`/checkin/plan/${p.id}/sow-now`); setPlans((ps) => ps.filter((x) => x.id !== p.id)); toast.success(pick(language, `${p.localName || p.cropName} बो दी गई! 🌱`, `${p.cropName} sown! 🌱`)); }
    catch { toast.error(pick(language, "नहीं हुआ", "Failed")); }
  };

  return (
    <motion.div variants={item} className="mb-5" data-testid="planned-crops">
      <div className="flex items-center gap-2 mb-3 px-1">
        <CalendarClock className="h-5 w-5 text-[#b06a2c]" />
        <h2 className="font-display text-lg font-extrabold text-[#16351d]">{pick(language, "योजना में फसलें", "Planned crops")}</h2>
      </div>
      <div className="space-y-3">
        {plans.map((p) => (
          <div key={p.id} data-testid={`planned-${p.id}`} className="rounded-2xl bg-white border border-[#f0e2bd] overflow-hidden shadow-[0_8px_30px_-20px_rgba(20,50,25,0.25)]">
            <div className="p-4 flex items-center gap-3">
              <span className="h-11 w-11 rounded-xl flex items-center justify-center text-2xl" style={{ background: "linear-gradient(135deg,#fdf6e6,#f6ecd0)" }}>{p.emoji || "🌱"}</span>
              <div className="flex-1 min-w-0">
                <p className="font-bold text-[15px] text-[#16351d]">{language === "हिंदी" ? (p.localName || p.cropName) : p.cropName}</p>
                <p className="text-[12px] text-[#8a6d1e] font-semibold">{p.daysToSow > 0 ? pick(language, `बुवाई ${p.daysToSow} दिन बाद`, `Sowing in ${p.daysToSow} days`) : pick(language, "बुवाई का समय आ गया!", "Time to sow!")}{p.fieldName ? ` · ${p.fieldName}` : ""}</p>
              </div>
              {p.daysToSow <= 0 ? (
                <button onClick={() => sowNow(p)} data-testid={`plan-sownow-${p.id}`} className="h-10 px-4 rounded-full bg-[#15803D] text-white font-bold text-sm flex items-center gap-1 animate-pulse"><Sprout className="h-4 w-4" />{pick(language, "बो दिया? हाँ", "Sowed? Yes")}</button>
              ) : (
                <button onClick={() => navigate(`/plant?cropId=${p.cropId}&plannedId=${p.id}`)} data-testid={`plan-sow-${p.id}`} className="h-10 px-4 rounded-full bg-[#15803D] text-white font-bold text-sm flex items-center gap-1"><Sprout className="h-4 w-4" />{pick(language, "बो दें", "Sow now")}</button>
              )}
            </div>
            {p.checklist?.length > 0 && (
              <div className="px-4 pb-4 pt-1 border-t border-[#f6efdc] grid grid-cols-2 gap-x-3 gap-y-1.5">
                {p.checklist.map((c, i) => (
                  <button key={i} onClick={() => toggle(p.id, c.k)} data-testid={`plan-item-${p.id}-${c.k}`}
                    className={`flex items-start gap-1.5 text-[12px] text-left ${c.done ? "text-[#9db29e] line-through" : "text-[#6c7a67]"}`}>
                    <span className={`h-4 w-4 mt-0.5 rounded-[5px] border shrink-0 flex items-center justify-center ${c.done ? "bg-[#15803D] border-[#15803D]" : "border-[#c3ccbf]"}`}>{c.done && <Check className="h-3 w-3 text-white" />}</span>
                    {pick(language, c.hi, c.en)}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </motion.div>
  );
}
